import { Link } from 'components/atoms';
import styled from 'styled-components';

export const BreadcrumbContainer = styled.nav`
  ol {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 0.25rem;
  }

  li {
    display: inline-flex;
    align-items: center;
    min-width: 0;
  }
`;

const desktopNoCssTruncation = `
  overflow: visible;
  text-overflow: clip;
  max-width: none;
`;

const mobileTabletTruncation = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BreadcrumbLink = styled(Link)`
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  ${mobileTabletTruncation}
  max-width: 180px;

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    max-width: 280px;
  }

  ${({ theme }) => theme.breakPoints.desktop} {
    ${desktopNoCssTruncation}
  }
`;

export const CrumbText = styled.span`
  color: #fff;
  font-weight: bold;
  font-size: ${({ theme }) => (theme.pxToRem ? theme.pxToRem(18) : '18px')};
  ${mobileTabletTruncation}
  max-width: 180px;

  ${({ theme }) => theme.breakPoints.tablet} {
    max-width: 280px;
  }

  ${({ theme }) => theme.breakPoints.desktop} {
    ${desktopNoCssTruncation}
  }
`;

export const Separator = styled.span`
  margin: 0 8px;
  color: #fff;
`;
